import { all, takeEvery, put, call, select } from 'redux-saga/effects'
import { REQUEST_USERS_LIST, REQUEST_DELETE_USER } from './constants'
import { setUsersList } from './actions'
import UsersClient from '../../apiClient/UsersClient'

const usersClient = new UsersClient()

function* getAll({ payload: { page, filter } }) {
    try {
        const { users, pagination } = yield call(usersClient.getAll, page, filter)

        yield put(setUsersList({ users, pagination }))

    } catch (e) {
        console.error(e)
        console.warn(e)
    }
}

function* deleteUser({ payload: { userId, filter } }) {
    try {
        const { userDeleted } = yield call(usersClient.deleteUser, userId)
        const page = yield select(({ users }) => users.pagination.page_number)
        yield getAll({ payload: { page, filter } })
    } catch (e) {
        console.warn(e)
    }
}

export default function* appSagas() {
    yield all([takeEvery(REQUEST_USERS_LIST, getAll), takeEvery(REQUEST_DELETE_USER, deleteUser)])
}
